import { render, staticRenderFns } from "./FlavorList.vue?vue&type=template&id=01020773&scoped=true&"
import script from "./FlavorList.vue?vue&type=script&lang=js&"
export * from "./FlavorList.vue?vue&type=script&lang=js&"
import style0 from "./FlavorList.vue?vue&type=style&index=0&id=01020773&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01020773",
  null
  
)

export default component.exports